import React, { useState } from 'react'
import { Box, TextField } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import { FxSelectProps } from './FxSelect.props'
import { FxLabel } from '../label/FxLabel'
import { FxValidation } from '../validation/FxValidation'

/**
 *
 * @param label
 * @param name
 * @param onValueChange
 * @param variant
 * @param size
 * @param valueField
 * @param displayField
 * @param selectedValue
 * @param options
 * @param className
 * @param placeholder
 * @param disabled
 * @param info
 * @param validations
 * @param validationResult
 * @param labelAlignment
 * @constructor
 */
export const FxSelect = (
  {
    label,
    textBoxLabel,
    name,
    path="",
    onValueChange,
    variant="outlined",
    size = "small",
    valueField,
    displayField,
    selectedValue,
    options = [],
    className,
    placeholder,
    disabled,
    info,
    validations,
    validationResult,
    labelAlignment = 'top'
  }: FxSelectProps
) => {
  const [onBlur, setOnBlur] = useState(false)
  /**
   *
   * @param event
   * @param value
   * @param reason
   */
  const onChange = (event: any, value: any, reason: string) => {
    console.log(name + ' : ' + value[valueField]);
    if (onValueChange) onValueChange({ name, value: value[valueField], path })
  }

  /**
   *
   */
  const getSelectedItem = () => 
    options.find(opt => opt[valueField] === selectedValue) || { [displayField]: "" }

    const isMandatory = () => {
      if (validations && validations.length > 0) {
        return validations.includes('comboRequired')
      }
    };
  
    const showTextBoxLbl = () => {
      if (isMandatory() && textBoxLabel) {
        return <>
          {textBoxLabel} <span className="text-danger">*</span>
        </>
      } else if(textBoxLabel){
        return <>{textBoxLabel}</>
      }
    }
  
    textBoxLabel = showTextBoxLbl()
  
  return (
    <>
      <div className={`fx-select ${labelAlignment == 'top' ? 'alignmentTop' : 'alignmentLeft'}`}>
      {label && <div><FxLabel info={info} label={label} validations={validations} /></div>}
        <Autocomplete
          fullWidth
          value={getSelectedItem()}
          options={options}
          getOptionLabel={(option: any) => option[displayField]}
          disableClearable
          disabled={disabled}
          onChange={onChange}
          size={size}
          renderInput={(params) => (
            <TextField
              {...params}
              label={textBoxLabel}
              className={`fx-select ${className}`}
              placeholder={placeholder}
              onFocus={() => setOnBlur(false)}
              onBlur={() => setOnBlur(true)}
              variant={variant === 'outlined' ? 'outlined' : 'standard'}
            />
          )}
        />
      </div>
      <FxValidation name={name}
        value={selectedValue}
        onBlur={onBlur}
        validations={validations}
        validationResult={validationResult}
      />
    </>
  )
}
